<div class="back-calender">
  <div class="container">
    <div class="row">
      <div class="col-12 back-link-outer mb-0 d-flex">
        <a class="back-link" role="button" (click)="goToBack()">
          <img alt="icon" src="../assets/images/back-grey.svg" /> Back To
          Auction Calendar
        </a>
      </div>
    </div>
  </div>
</div>

<div class="details-banner text-center">
  <img class="auction-details-banner" alt="logo" [src]="responseData?.coverPhoto ? responseData?.coverPhoto : '/assets/images/banner-bg.jpg'" />
  <div class="container">
    <div class="row">
      <div class="col-12"></div>
    </div>
  </div>
</div>

<div class="details-tabs-outer">
  <div class="container">
    <div class="row">
      <div class="left-wrap">
        <div class="left-wrap-inner">
          <img class="auction-logo img-fluid" alt="auction-logo" *ngIf="responseData"
            [src]="responseData?.clientLogo" />
        </div>
      </div>

      <div class="right-wrap" #top>
        <h1 class="auction-name" [title]="responseData?.title">
          {{ responseData?.title | characterLimit: 30 }}
        </h1>
        <div class="details-tabs tabsDark">
          <div class="list-filter-tabs detailsWithNum">
            <button class="list-tab" [ngClass]="{
                active: stepActive == 1,
                'completed-tab': stepActive > 1
              }" role="button" (click)="changeSteps(1)">
              <span class="stepNum">1</span>
              Auction Details
            </button>
            <button class="list-tab" [ngClass]="{
                active: stepActive == 2,
                'completed-tab': stepActive > 2
              }" role="button" (click)="changeSteps(2)">
              <span class="stepNum">2</span> Photo Gallery
            </button>
            <button class="list-tab" [ngClass]="{
                active: stepActive == 3,
                'completed-tab': stepActive > 3
              }" role="button" (click)="changeSteps(3)">
              <span class="stepNum">3</span> Payment & Terms
            </button>
            <button class="list-tab" [ngClass]="{
                active: stepActive == 4,
                'completed-tab': stepActive > 4
              }" role="button" (click)="changeSteps(4)">
              <span class="stepNum">4</span> Lot Removal & Logistics
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="auction-details-wrap" *ngIf="showView">
  <div class="container">
    <div class="details-wrap-inner">
      <div class="details-tab-data">
        <div>
          <div class="for-tabs row">
            <div class="col-lg-8 left-tabs-wrapper">
              <div class="details-step1" *ngIf="stepActive == 1">
                <p class="details-des">{{ responseData?.byOrderOf }}</p>
                <h2 class="auction-wrap-hdg mb-3">{{ responseData?.title }}</h2>
                <div class="pt-1 d-flex mb-2">
                  <span class="card-badge no-card min-width-auto badge-dark">{{ responseData?.saleType.publicName }}
                  </span>
                </div>
                <p class="details-des2" [innerHTML]="responseData?.tagline"></p>

                <div class="date-wrap-outer">
                  <div *ngIf="
                      responseData?.auctionStatus == 3 ||
                      responseData?.auctionStatus == 2 ||
                      responseData?.auctionStatus == 1
                    ">
                    <ng-container [ngSwitch]="responseData?.saleType?.auctionDate">
                      <div class="date-wrap" *ngSwitchCase="1">
                        <div class="top">
                          <img class="date-icon" alt="calender" src="/assets/images/calender.svg" />
                          <span>{{
                            responseData?.auctionStatus == 1
                            ? "Opened"
                            : "Opens"
                            }}
                          </span>
                        </div>
                        <p class="m-0">
                          {{
                          responseData?.startDateTime
                          | toLocalDateTime
                          : false
                          : responseData?.timeZoneName
                          : "EEEE, MMMM d, y h:mm a"
                          }}
                        </p>
                      </div>

                      <div class="date-wrap" *ngSwitchCase="2">
                        <div class="top">
                          <img class="date-icon" alt="calender" src="/assets/images/calender.svg" />
                          <span>Closing begins</span>
                        </div>
                        <p class="m-0">
                          {{
                          responseData?.endDateTime
                          | toLocalDateTime
                          : false
                          : responseData?.timeZoneName
                          : "EEEE, MMMM d, y h:mm a"
                          }}
                        </p>
                      </div>

                      <div *ngSwitchCase="3">
                        <div class="date-wrap">
                          <div class="top">
                            <img class="date-icon" alt="calender" src="/assets/images/calender.svg" />
                            <span>{{
                              responseData?.auctionStatus == 1
                              ? "Opened"
                              : "Opens"
                              }}
                            </span>
                          </div>
                          <p class="m-0">
                            {{
                            responseData?.startDateTime
                            | toLocalDateTime
                            : false
                            : responseData?.timeZoneName
                            : "EEEE, MMMM d, y h:mm a"
                            }}
                          </p>
                        </div>
                        <div class="date-wrap">
                          <div class="top">
                            <img class="date-icon" alt="calender" src="/assets/images/calender.svg" />
                            <span>Closing begins</span>
                          </div>
                          <p class="m-0">
                            {{
                            responseData?.endDateTime
                            | toLocalDateTime
                            : false
                            : responseData?.timeZoneName
                            : "EEEE, MMMM d, y h:mm a"
                            }}
                          </p>
                        </div>
                      </div>
                    </ng-container>
                  </div>

                  <div *ngIf="responseData?.auctionStatus == 4">
                    <div class="date-wrap">
                      <div class="top">
                        <img class="date-icon" alt="calender" src="/assets/images/calender.svg" />
                        <span>Closing Began</span>
                      </div>
                      <p class="m-0">
                        {{
                        responseData?.endDateTime
                        | toLocalDateTime
                        : false
                        : responseData?.timeZoneName
                        : "EEEE, MMMM d, y h:mm a"
                        }}
                      </p>
                    </div>
                  </div>

                  <div class="date-wrap-address" *ngIf="locations && locations.length > 0">
                    <div class="top">
                      <img class="date-icon" alt="calender" src="/assets/images/location-grey.svg" />
                      <span>Location</span>
                    </div>
                    <p class="m-0">
                      <strong *ngFor="let location of locations; let last = last">
                        <ng-container *ngIf="location.locationLink; else withoutLink">
                          <a href="{{ location.locationLink }}" [innerHTML]="location.address" class="address-link" target="_blank">
                          </a>
                        </ng-container>
                        <ng-template #withoutLink>
                          <span [innerHTML]="location.address"></span>
                        </ng-template>
                      </strong>
                    </p>
                  </div>
                </div>

                <div class="step-list-details">
                  <div class="list-details-subpart" *ngIf="responseData?.featuredItems">
                    <h4 class="style3 mb-3">Featured Items</h4>
                    <h4 class="style4 mb-2">
                      {{ responseData?.featuredItemHeader }}
                    </h4>
                    <div class="details-list" [innerHTML]="responseData?.featuredItems | sanitizedHtml"></div>
                  </div>
                </div>
              </div>

              <div class="details-step2" *ngIf="stepActive == 2 && !showBlank">
                <h2 class="auction-wrap-hdg mb-3">Photo Gallery</h2>

                <div class="empty-state-container empty-pad-2" *ngIf="photoGallery?.length === 0; else showGrid">
                  <div class="empty-state-content">
                    <img alt="empty-state" src="../../../../assets/images/the-branford-logo.svg" />
                    <h3 class="_heading">Photos Coming Soon</h3>
                  </div>
                </div>

                <ng-template #showGrid>
                  <div class="container" *ngIf="!showBlank">
                    <div class="row">
                      <div class="col-12 gallery-pagination">
                        <app-paginator [paginationId]="'server'" [currentPage]="pageNumber" [pageSize]="pageSize"
                          (page)="onPageChange($event)" *ngIf="photoGallery.length > pageSize">
                        </app-paginator>
                      </div>
                    </div>
                  </div>
                  <div class="details-step2-data">
                    <div class="details-step2-images">
                      <ul class="no-list slide-images-list">
                        <li *ngFor="
                          let picture of photoGalleryThumbnail
                            | paginate
                              : {
                                  id: 'server',
                                  itemsPerPage: pageSize,
                                  currentPage: pageNumber,
                                  totalItems: photoGallery.length
                                }
                        ">
                          <a href="{{ picture.name }}" rel="prettyPhoto[pp_gal]" class="prettyPhotoWrapper">
                            <img alt="auction-image" class="cursor-pointer preview-image" src="{{ picture.thumb }}" imgFallback="{{ picture.name }}"  />
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="container">
                    <div class="row">
                      <div class="col-12 gallery-pagination">
                        <app-paginator [paginationId]="'server'" [currentPage]="pageNumber" [pageSize]="pageSize"
                          (page)="onPageChange($event)" *ngIf="photoGallery.length > pageSize">
                        </app-paginator>
                      </div>
                    </div>
                  </div>
                </ng-template>
              </div>

              <div class="details-step1" *ngIf="stepActive == 3">
                <h2 class="auction-wrap-hdg mb-3">Payment & Terms</h2>
                <div class="auction-payment">
                  <ng-container *ngIf="
                      responseData?.saleType.registrationDepositeRules != ''
                    ">
                    <h3 class="payment-hdg">Registration & Deposit Rules</h3>
                    <p class="payment-des" [innerHTML]="
                        responseData?.saleType.registrationDepositeRules
                      "></p>
                  </ng-container>

                  <ng-container *ngIf="responseData?.paymentInstructions">
                    <h3 class="payment-hdg">Payment Instructions</h3>
                    <p class="payment-des" [innerHTML]="responseData?.paymentInstructions"></p>
                  </ng-container>

                  <h3 class="payment-hdg">Currency</h3>
                  <p class="payment-des">{{ responseData?.currencyName }}</p>

                  <ng-container *ngIf="responseData?.generalBuyersPremium != '0'">
                    <h3 class="payment-hdg">Buyers Premium</h3>
                    <p class="payment-des" *ngIf="responseData?.creditCardBuyersPremiumText == 'null' || isNumberOrStringNumber(responseData?.creditCardBuyersPremiumText); else ccBlock"
                      [innerHTML]="responseData?.generalBuyersPremiumText"></p>
                    <ng-template #ccBlock>
                      <p class="payment-des" [innerHTML]="responseData?.creditCardBuyersPremiumText"></p>
                    </ng-template>
                  </ng-container>

                  <ng-container *ngIf="locations && locations?.length > 0">
                    <h3 class="payment-hdg">Tax Rates</h3>
                    <ng-container *ngFor="let location of locations">
                      <p class="payment-des">
                        <img class="location mr-2" alt="location" src="../assets/images/location-green.svg" />
                        <strong>
                          <ng-container *ngIf="location.locationLink; else withoutLink">
                            <a href="{{ location.locationLink }}" target="_blank">
                              {{ location.name }}
                            </a>
                          </ng-container>
                          <ng-template #withoutLink>
                            {{ location.name }}
                          </ng-template>
                        </strong>
                      </p>
                      <p class="payment-des">
                        <strong>
                          {{
                          location?.salesTaxRate != null
                          ? (location.salesTaxRate | number) + "%"
                          : "TBD"
                          }}
                        </strong>
                      </p>
                      <p class="payment-des" [innerHTML]="location.salesTaxDetail"></p>
                    </ng-container>
                  </ng-container>

                  <h3 class="payment-hdg mb-3">Terms & Conditions</h3>
                  <p class="payment_Wrap payment-des termWrapPad" [innerHTML]="tAndC"></p>
                </div>

                <div class="doc-download">
                  <h3 class="doc-hdg">Payment Documents</h3>
                  <ng-container *ngFor="let doc of paymentDocuments">
                    <div class="parts">
                      <div class="left-wrap">
                        <img class="doc-icon" alt="doc" src="../assets/images/file.svg" />
                        <span>{{ doc.title }}</span>
                      </div>
                      <div class="right-wrap">
                        <a [href]="doc.name" [download]="doc.title" target="_blank">
                          <img class="download" alt="download" src="../assets/images/download.svg" />
                        </a>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>

              <div class="details-step1" *ngIf="stepActive == 4">
                <h2 class="auction-wrap-hdg mb-3">Lot Removal & Logistics</h2>

                <ng-container *ngIf="locations && locations.length > 0">
                  <h2 class="auction-lot-sb-hdg mb-3">
                    {{ locations.length }} Equipment Location(s)
                  </h2>
                  <div class="lot-details-wrapper">
                    <div class="top-slider">
                      <div class="row lotLogistics-slider-outer">
                        <div class="col-12 lotLogistics-slider">
                          <div class="lotLogistics-slider-wrap">
                            <ngx-slick-carousel class="carousel lotHeader m-0" [config]="lotLogistics">
                              <ng-container *ngFor="let location of locations">
                                <div ngxSlickItem class="slide">
                                  <div class="slide-top">
                                    <img alt="location" src="../assets/images/location-green.svg" class="mr-2" />
                                    <span>
                                      <ng-container *ngIf="
                                          location.locationLink;
                                          else withoutLink
                                        ">
                                        <a href="{{ location.locationLink }}" target="_blank">
                                          {{ location.name }}
                                        </a>
                                      </ng-container>
                                      <ng-template #withoutLink>
                                        {{ location.name }}
                                      </ng-template>
                                    </span>
                                  </div>
                                  <div class="slide-bottom">
                                    {{
                                    location?.lotNumbers
                                    ? "Lot - " + location?.lotNumbers
                                    : "TBD"
                                    }}
                                  </div>
                                </div>
                              </ng-container>
                            </ngx-slick-carousel>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="address-dtls top-slider">
                      <div class="row lotLogistics-slider-outer">
                        <div class="col-12 lotLogistics-slider">
                          <div class="lotLogistics-slider-wrap">
                            <ngx-slick-carousel class="carousel lotNav m-0" [config]="lotLogisticsNav">
                              <ng-container *ngFor="let location of locations">
                                <div ngxSlickItem class="slide">
                                  <div class="dtl-wrap">
                                    <h3 class="hdg">Address</h3>
                                    <p class="des" [innerHTML]="location.address | sanitizedHtml"></p>

                                    <h3 class="hdg">Removal</h3>
                                    <p class="des" [innerHTML]="location.removalDateAndRules | sanitizedHtml"></p>

                                    <h3 class="hdg">Rigging/Shipping</h3>
                                    <p class="des" [innerHTML]="location.riggingAndShipping | sanitizedHtml"></p>
                                  </div>
                                </div>
                              </ng-container>
                            </ngx-slick-carousel>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>

                <div class="doc-download">
                  <h3 class="doc-hdg">Removal Documents</h3>
                  <ng-container *ngFor="let doc of removalDocuments">
                    <div class="parts">
                      <div class="left-wrap">
                        <img class="doc-icon" alt="doc" src="../assets/images/file.svg" />
                        <span>{{ doc.title }}</span>
                      </div>
                      <div class="right-wrap">
                        <a [href]="doc.name" [download]="doc.title" target="_blank">
                          <img class="download" alt="download" src="../assets/images/download.svg" />
                        </a>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </div>
            </div>

            <div class="col-lg-4 right-tabs-wrapper">
              <!-- this is Inquiry Form for 'inquiry type registration' -->
              <div class="registration-open mb-3" *ngIf="
                  responseData?.saleType.registrationFormat ===
                  registrationFormats.inquiryForm
                ">
                <div class="top">
                  <div class="registration-left">
                    <img alt="icon" class="registration-icon" src="/assets/images/auction-success-icon.svg" />
                  </div>
                  <div class="registration-right">
                    <h1 class="hdg">Inquire Now!</h1>
                    <p class="des">Inquire now for this auction.</p>
                  </div>
                </div>
                <div class="btm">
                  <button [disabled]="forPublicClient" type="button" class="btn btn-colored" role="button"
                    (click)="goToEnquiryPage()">
                    Inquire Now
                  </button>
                </div>
              </div>

              <!-- this container will use for 3rd party registeration system -->
              <ng-container *ngIf="
                  (responseData?.saleType.registrationFormat ==
                  registrationFormats.thirdPartyRegistration) &&
        responseData?.registrationLinkUrl

                ">
                <div class="registration-open mb-3">
                  <div class="top">
                    <div class="registration-left">
                      <img alt="icon" class="registration-icon" src="/assets/images/auction-success-icon.svg" />
                    </div>
                    <div class="registration-right">
                      <h1 class="hdg">Registration</h1>
                      <p class="des">
                        Click on the link below to Register for the auction.
                        When the auction opens, bidding will take place at the
                        linked site.
                      </p>
                    </div>
                  </div>
                  <div class="btm">
                    <a role="button" class="btn btn-colored" [ngClass]="{
                        'disabled-link': !responseData?.registrationLinkUrl
                      }" [href]="responseData?.registrationLinkUrl" target="_blank">
                      {{responseData.saleType.registrationFormat == 2 && responseData.saleType.isCatalogUploadAllowed ? "Register & Bid" : "Register"}}
                    </a>
                  </div>
                </div>
              </ng-container>

              <!-- this container will use for tbg registration system -->
              <ng-container *ngIf="
                  responseData?.saleType.registrationFormat ==
                    registrationFormats.tbgRegistration &&
                  (responseData?.auctionStatus == auctionStatuses.live ||
                    responseData?.auctionStatus == auctionStatuses.upcoming) &&
                  responseData?.saleType.isCatalogUploadAllowed
                ">
                <!-- related to registeration button -->
                <div class="registration-open mb-3">
                  <div class="top">
                    <div class="registration-left">
                      <img alt="icon" class="registration-icon" src="/assets/images/auctionregistration.svg" />
                    </div>

                    <div class="registration-right">
                      <ng-container *ngIf="
                          responseData?.loggedInUser == null;
                          else checkApproval
                        ">
                        <h1 class="hdg">
                          {{
                          responseData?.isRegistrationActive
                          ? "Registration Open !"
                          : "Registration will open soon !"
                          }}
                        </h1>
                        <p class="des" *ngIf="responseData?.isRegistrationActive">
                          Register now for this auction to bid and receive
                          bidding instructions.
                        </p>
                      </ng-container>
                      <ng-template #checkApproval>
                        <h1 class="hdg">
                          {{
                          responseData?.loggedInUser.isApproved
                          ? "Approved!"
                          : "Awaiting Approval!"
                          }}
                        </h1>
                        <p class="des">
                          <span *ngIf="responseData?.loggedInUser?.isApproved">
                            Your registration request has been approved.
                            <br />
                          </span>
                          Your Bidder Number for this auction is
                          <strong>{{ responseData?.loggedInUser?.paddleNumber }}
                          </strong>
                        </p>
                      </ng-template>
                    </div>
                  </div>

                  <div class="btm" *ngIf="
                      responseData?.isRegistrationActive &&
                      responseData?.isApproved &&
                      !responseData?.loggedInUser?.isRegistered
                    ">
                    <button type="button" [disabled]="forPublicClient" class="btn btn-colored" role="button"
                      (click)="goToRegister()">
                      Register To Bid
                    </button>
                  </div>
                </div>
              </ng-container>

              <!-- this is for sold entirely -->
              <div class="registration-open registration-lot mb-3" *ngIf="responseData?.isSold">
                <div class="badge-type">
                  <span class="card-badge-colored mr-2">SOLD</span>
                </div>
                Sold In Its Entirety
              </div>

              <!-- this container is for lot catalog -->
              <ng-container *ngIf="
                  responseData?.saleType.isCatalogUploadAllowed;
                  else notAllowed
                ">
                <ng-container *ngIf="isLots; else noLotsYet">
                  <div class="registration-open mb-3">
                    <div class="top">
                      <div class="registration-left">
                        <img alt="icon" class="registration-icon" src="/assets/images/auctionLot.svg" />
                      </div>
                      <div class="registration-right">
                        <h1 class="hdg">Auction Lot Catalog</h1>
                        <p class="des">
                          <ng-container *ngIf="
                              responseData?.auctionStatus !==
                              auctionStatuses.past
                            ">
                            {{
                            isBiddingOpen
                            ? "Bidding is open and you can start bidding online"
                            : "View lot catalog items for this auction."
                            }}
                          </ng-container>
                        </p>
                      </div>
                    </div>
                    <div class="btm">
                      <button type="button" [disabled]="forPublicClient" class="btn btn-colored" role="button"
                        (click)="goToLotsSection()">
                        <ng-container *ngIf="
                            responseData?.auctionStatus !==
                              auctionStatuses.past;
                            else archievedCatalog
                          ">
                          {{ isBiddingOpen ? "Bid Now" : "View Lot Catalog" }}
                        </ng-container>
                        <ng-template #archievedCatalog>
                          View Archived Lot Catalog
                        </ng-template>
                      </button>
                    </div>
                  </div>
                </ng-container>
                <ng-template #noLotsYet>
                  <ng-container *ngIf="
                      ![
                        auctionStatuses.past,
                        auctionStatuses.archived
                      ].includes(responseData?.auctionStatus)
                    ">
                    <div class="coming-soon-outer mb-3">
                      <h1 class="hdg">Auction Lot Catalog</h1>
                      <h3 class="coming-soon m-0">COMING <br />SOON</h3>
                    </div>
                  </ng-container>
                </ng-template>
              </ng-container>
              <ng-template #notAllowed>
                <div class="registration-open mb-3" *ngIf="responseData?.catalogLinkUrl">
                  <div class="top">
                    <div class="registration-left">
                      <img alt="icon" class="registration-icon" src="/assets/images/auctionLot.svg" />
                    </div>
                    <div class="registration-right">
                      <h1 class="hdg">Auction Lot Catalog</h1>
                      <p class="des">
                        Click on below button "Lot Catalog" to view catalog and bid
                      </p>
                    </div>
                  </div>
                  <div class="btm">
                    <a role="button" class="btn btn-colored" [ngClass]="{
                        'disabled-link': !responseData?.catalogLinkUrl
                      }" [href]="responseData?.catalogLinkUrl" target="_blank">
                      {{ getButtonText(responseData) }}
                    </a>
                  </div>
                </div>
              </ng-template>

              <ng-container *ngIf="
                  (customButtons && customButtons?.length) ||
                  responseData?.saleType?.showHelpText !== helpTexts.none ||
                  responseData?.auctionStatus !== auctionStatuses.past
                ">
                <div class="preview-icons mb-3">
                  <ng-container *ngIf="responseData?.auctionStatus !== auctionStatuses.past">
                    <div class="icon-wrap" role="button" (click)="createCalenderEvent()">
                      <div class="for-icon">
                        <img alt="icon" class="preview-icon" src="/assets/images/add-to-calender.svg" />
                      </div>
                      <div>
                        <a class="for-name" role="button">Add To Calendar</a>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="customButtons && customButtons?.length">
                    <div class="icon-wrap" *ngFor="let document of customButtons">
                      <div class="for-icon">
                        <a href="{{
                            document.isUrl
                              ? document.url
                              : document.auctionFileName
                          }}" target="_blank">
                          <img alt="icon" class="preview-icon" src="{{ document.buttonName }}" />
                        </a>
                      </div>
                      <div>
                        <a class="for-name" href="{{
                            document.isUrl
                              ? document.url
                              : document.auctionFileName
                          }}" target="_blank">{{ document.label }}</a>
                      </div>
                    </div>
                  </ng-container>

                  <ng-container *ngIf="
                      ![0, helpTexts.none].includes(
                        responseData?.saleType?.showHelpText
                      )
                    ">
                    <div class="icon-wrap">
                      <div class="for-icon" role="button" (click)="openHelpModal(helpTemplate)">
                        <img alt="icon" class="preview-icon" src="/assets/images/auction-help.svg" />
                      </div>
                      <div>
                        <a class="for-name">Help</a>
                      </div>
                    </div>
                  </ng-container>
                </div>
              </ng-container>

              <ng-container *ngIf="locations && locations.length > 0">
                <div class="customAccord mb-3">
                  <h3 class="inspectionHdg">Inspection/Preview</h3>
                  <accordion [closeOthers]="true" [isAnimated]="true">
                    <accordion-group *ngFor="let location of locations; first as firstLocation"
                      [isOpen]="firstLocation">
                      <div class="clearfix" accordion-heading type="button">
                        <div class="forHdg">
                          <ng-container *ngIf="location.locationLink; else withoutLink">
                            <a href="{{ location.locationLink }}" target="_blank">
                              {{ location.name }}
                            </a>
                          </ng-container>
                          <ng-template #withoutLink>
                            {{ location.name }}
                          </ng-template>
                        </div>
                        <span class="forArrow">
                          <img alt="icon" class="registration-icon" src="/assets/images/accord-arrow.svg" />
                        </span>
                      </div>
                      <div class="AccordDtls" [innerHTML]="location.inspectionPreview"></div>
                    </accordion-group>
                  </accordion>
                </div>
              </ng-container>

              <ng-container *ngIf="contacts && contacts.length > 0">
                <div class="auction-contacts mb-3">
                  <h1 class="main-hdg">Auction Contacts</h1>
                  <div class="box">
                    <div class="inner-box" *ngFor="let contact of contacts">
                      <h1 class="hdg">{{ contact.description | isEmpty }}</h1>
                      <h3 class="name">{{ contact.contactName | isEmpty }}</h3>
                      <p class="des" *ngIf="contact.email">
                        <a href="mailto:{{ contact.email | isEmpty: '' }}">
                          {{ contact.email | isEmpty: "" }}
                        </a>
                      </p>
                      <p class="des">
                        {{ contact.mobileNumber | isEmpty: "" }}
                      </p>
                    </div>
                  </div>
                </div>
              </ng-container>

              <ng-container class="related-sales" *ngIf="relatedAuctions && relatedAuctions.length > 0">
                <div class="row">
                  <div class="col-12">
                    <h1 class="inspectionHdg">Related Sales</h1>
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mb-5" *ngFor="let data of relatedAuctions">
                    <auction-card [auctionData]="data" [listView]="false" class="mb-5"></auction-card>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>

          <div *ngIf="stepActive == 1">
            <div class="row aution-slider-outer" *ngIf="sliderImagesThumbnail && sliderImagesThumbnail.length > 0">
              <div class="col-12 auction-details-slider">
                <div class="auction-details-slider-wrap custon-slick-dots">
                  <ngx-slick-carousel class="carousel m-0" [config]="auctionDetailsSlider">
                    <div ngxSlickItem #slide class="slide" *ngFor="let image of sliderImagesThumbnail">
                      <a id="myLink" href="{{ image?.name }}" rel="prettyPhoto[pp_gal1]" class="prettyPhotoSlideWrapper">
                        <img alt="auction-image" class="cursor-pointer preview-image" src="{{ image?.thumb }}" imgFallback="{{ image?.name }}"  />
                      </a>
                    </div>
                  </ngx-slick-carousel>
                </div>
              </div>
            </div>
          </div>

          <div *ngIf="stepActive == 1">
            <div *ngIf="partnerLogos && partnerLogos.length > 0" class="row inconjuction-outer">
              <div class="col-12 inconjuction">
                <div class="main-inconj d-flex">
                  <div class="left-wrap">
                    <p class="m-0">In Conjunction With</p>
                  </div>
                  <div class="right-wrap">
                    <span class="right-wrap-inner" *ngFor="let conjunction of partnerLogos">
                      <img class="img-fluid" alt="inconjuction-logo" src="{{ conjunction.name }}" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="row" *ngIf="stepActive == 1">
            <div class="next-prev">
              <button type="button" class="btn btn-colored next-btn ml-auto" role="button"
                (click)="scrollToTop(2, top)">
                NEXT : Photo Gallery
                <img alt="next-arrow" class="next-icon ml-2" src="../assets/images/next.svg" />
              </button>
            </div>
          </div>

          <div class="row" *ngIf="stepActive == 2">
            <div class="next-prev">
              <button type="button" class="btn btn-colored prev-btn" role="button" (click)="scrollToTop(1, top)">
                <img alt="prev-icon" class="prev-icon mr-2" src="../assets/images/prev.svg" />
                PREV : Auction Details
              </button>
              <button type="button" class="btn btn-colored next-btn" role="button" (click)="scrollToTop(3, top)">
                NEXT : Payment & Terms
                <img alt="next-arrow" class="next-icon ml-2" src="../assets/images/next.svg" />
              </button>
            </div>
          </div>

          <div class="row" *ngIf="stepActive == 3">
            <div class="next-prev">
              <button type="button" class="btn btn-colored prev-btn" role="button" (click)="scrollToTop(2, top)">
                <img alt="prev-icon" class="prev-icon mr-2" src="../assets/images/prev.svg" />
                PREV : Photo Gallery
              </button>
              <button type="button" class="btn btn-colored next-btn" role="button" (click)="scrollToTop(4, top)">
                NEXT : Lot Removal & Logistics
                <img alt="next-arrow" class="next-icon ml-2" src="../assets/images/next.svg" />
              </button>
            </div>
          </div>

          <div class="row" *ngIf="stepActive == 4">
            <div class="next-prev">
              <button type="button" class="btn btn-colored prev-btn" role="button" (click)="scrollToTop(3, top)">
                <img alt="prev-icon" class="prev-icon mr-2" src="../assets/images/prev.svg" />
                PREV : Payment & Terms
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #helpTemplate>
  <div class="modal-header">
    <h4 class="modal-title pull-left">Help</h4>
    <button type="button" class="close pull-right circle-icon m-0" aria-label="Close" role="button"
      (click)="modalRef.hide()">
      <img alt="icon" src="../assets/images/cross.svg" />
    </button>
  </div>

  <div class="modal-body">
    <h1 class="modal-inner-hdg mt-0 mb-2">
      {{
      this.responseData?.saleType.showHelpText ===
      this.helpTexts.catalogBidding
      ? "Catalog & Bidding"
      : "Read Only Catalog"
      }}
    </h1>
    <div class="des" [innerHTML]="helpTextData"></div>
  </div>
</ng-template>
